export default function CipherTable({ data }) {
  return (
    <div className="lg:col-span-2 panel">
      <div className="px-6 py-4 border-b border-white/10 flex items-center justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] muted">Phrase</div>
          <div className="font-display text-2xl mt-1">{data.text}</div>
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] muted">
          {data.breakdown.length} ciphers
        </div>
      </div>
      <table className="cipher-table" data-testid="cipher-results-table">
        <thead>
          <tr>
            <th>Cipher</th>
            <th style={{ width: "30%" }}>Value</th>
          </tr>
        </thead>
        <tbody>
          {data.breakdown.map((b) => (
            <tr key={b.key} data-testid={`cipher-row-${b.key}`}>
              <td className="muted">{b.label}</td>
              <td className="gold text-base">{b.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
